import * as Validator from "yup"

export const passwordValidatorRegex =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>\-~`_+=';/])[A-Za-z\d!@#$%^&*(),.?":{}|<>\-~`_+=';/]{8,15}$/

export const passwordValidator = Validator.string().matches(
	passwordValidatorRegex,
	"Please provide stronger password"
)
